import React, { useState, useEffect } from "react";
import classes from "./Review.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import Ratings from "react-star-ratings";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";

export const ReviewModal = ({
  show,
  setShow,
  title,
  detail,
  setDetail,
  privateDetail,
  setPrivateDetail,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [stepsCount, setStepsCount] = useState(1);
  const [rating, setRating] = useState([
    {
      title: "Accuracy",
      stars: 0,
      isSelected: false,
    },
    {
      title: "Location",
      stars: 0,
      isSelected: false,
    },
    {
      title: "Value",
      stars: 0,
      isSelected: false,
    },
    {
      title: "Communication",
      stars: 0,
      isSelected: false,
    },
    {
      title: "Fast response",
      stars: 0,
      isSelected: false,
    },
  ]);

  const [experience, setExperirence] = useState([
    {
      title: "Friendly",
      isSelected: false,
    },
    {
      title: "Patient",
      isSelected: false,
    },
    {
      title: "Supportive",
      isSelected: false,
    },
    {
      title: "Goal orientated",
      isSelected: false,
    },
    {
      title: "Encouraging",
      isSelected: false,
    },
    {
      title: "Focused",
      isSelected: false,
    },
    {
      title: "Trusting",
      isSelected: false,
    },
    {
      title: "Positive",
      isSelected: false,
    },
    {
      title: "Clear communicator",
      isSelected: false,
    },
    {
      title: "Disciplined",
      isSelected: false,
    },
    {
      title: "Prepared",
      isSelected: false,
    },
  ]);

  const changeRating = (newRating, i) => {
    let newArray = [...rating];
    newArray[i].stars = newRating;
    newArray[i].isSelected = true;
    setRating(newArray);
  };

  const ChangeExperience = (i) => {
    let newArray = [...experience];
    newArray[i].isSelected = !newArray[i].isSelected;
    setExperirence(newArray);
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);

  return (
    <>
      <style>{`
          .modal-body{
            padding:32px;
            padding-top:0;
          }
          @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
          }
          @media screen and (max-width: 768px) {
              .${modalClasses.body} {
                padding:0px 24px;
              }
              .${modalClasses.header} {
                  margin:24px;
                }
          }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={
          isMobile
            ? {
                padding: "16px 24px",
                margin: "0px",
              }
            : {
                padding: "16px 32px",
                margin: "0px",
              }
        }
        width={"509px"}
        header={
          <div>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfDimGray,
                fontSize: "12px",
                lineHeight: "16px",
              }}
              className={[stepsCount !== undefined && classes.mb8].join(" ")}
            >
              {stepsCount} out of 3
            </p>
            <h4
              style={
                isMobile
                  ? {
                      ...Fonts.h5,
                      fontSize: "24px",
                      lineHeight: "32px",
                      color: Colors.neutralShadesOfNero,
                    }
                  : {
                      ...Fonts.h4,
                      fontSize: "26px",
                      color: Colors.neutralShadesOfNero,
                    }
              }
            >
              {title}
            </h4>
          </div>
        }
        footer={
          <>
            {stepsCount === 1 && (
              <div className={classes.footerBtns}>
                <Button
                  label={"Cancel"}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "95px",
                    marginRight: "24px",
                    backgroundColor: Colors.white,
                    border: "none",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                />
                <Button
                  label={"Next"}
                  primary={true}
                  size={"Large"}
                  customStyle={{
                    width: "120px",
                    height: "48px",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                  onClick={() => setStepsCount(2)}
                />
              </div>
            )}
            {stepsCount === 2 && (
              <div className={classes.footerBtns}>
                <Button
                  label={"Cancel"}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "95px",
                    marginRight: "24px",
                    backgroundColor: Colors.white,
                    border: "none",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                />
                <Button
                  label={"Skip"}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "120px",
                    height: "48px",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                  onClick={() => setStepsCount(3)}
                />
              </div>
            )}
            {stepsCount === 3 && (
              <div className={classes.footerBtns}>
                <Button
                  label={"Cancel"}
                  primary={false}
                  size={"Large"}
                  customStyle={{
                    width: "95px",
                    marginRight: "24px",
                    backgroundColor: Colors.white,
                    border: "none",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                />
                <Button
                  label={"Done"}
                  primary={true}
                  size={"Large"}
                  customStyle={{
                    width: "120px",
                    height: "48px",
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                  disabled={!rating?.some((r) => r?.isSelected)}
                />
              </div>
            )}
          </>
        }
      >
        <div className={classes.modalContent}>
          {stepsCount === 1 && (
            <>
              <div className={classes.textAreaDiv}>
                <TextArea
                  state={detail}
                  setter={setDetail}
                  label={`What are the highlights of your coaching lesson (Your review  will be published in the coach's profile)`}
                  placeholder="Details"
                />
              </div>
              <div className={[classes.mb24]}>
                <p
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.p2,
                    fontSize: "14px",
                    lineHeight: "21px",
                    marginBottom: "16px",
                  }}
                >
                  Tell us more
                </p>
                <div className={[classes.experienceDiv]}>
                  {experience?.map((item, i) => {
                    return (
                      <div
                        className={[classes.experienceBox]}
                        style={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                          ...Fonts.p2,
                          backgroundColor: `${
                            item?.isSelected
                              ? Colors.neutralShadesOfNero
                              : Colors.white
                          }`,
                          color: `${
                            item?.isSelected
                              ? Colors.white
                              : Colors.neutralShadesOfNero
                          }`,
                        }}
                        onClick={() => ChangeExperience(i)}
                      >
                        {item?.title}
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
          {stepsCount === 2 && (
            <>
              <div className={classes.textAreaDiv}>
                <TextArea
                  state={privateDetail}
                  setter={setPrivateDetail}
                  label={`Private feedback (This feedback is just for the coach to see. We will not make it public)`}
                  placeholder="Details"
                />
              </div>
            </>
          )}
          {stepsCount === 3 && (
            <>
              {rating?.map((item, i) => {
                return (
                  <div className={classes.starDiv} key={i}>
                    <p
                      style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}
                    >
                      {item?.title}
                    </p>

                    <Ratings
                      numberOfStars={5}
                      starRatedColor={Colors.mainShadeOfRed}
                      starEmptyColor={Colors.neutralShadesOfGainsboro}
                      rating={item?.stars}
                      starDimension="24px"
                      starSpacing={3}
                      changeRating={(e) => changeRating(e, i)}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      </ModalSkeleton>
    </>
  );
};
